module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Home')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-270ffa32!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cider.vue
// module id = 364
// module chunks = 1